import type { ConfigProviderProps } from 'antd/es/config-provider';

const datePickerConfig: ConfigProviderProps['datePicker'] = {
  suffixIcon: <i className="fb-icon--calendar text-secondary" />,
};

export default datePickerConfig;
